export default __webpack_public_path__ + "img/34aa6584eb3d7d53132372a79d453ca5.png";